import BaseEditForm from '../BaseEditForm.js'
import TextInput from '../../../../common/components/Form/TextInput.js'
import Row from '../../../../common/components/Form/Row.js'
import Select from '../../../../common/components/Form/Select.js'
import TextArea from '../../../../common/components/Form/TextArea.js'
import EditLine from './EditLine.js'
import {useSelector} from '../../../../store.js'
import {warehouseOptionsSelector} from '../../../../data/warehouses.js'

export default function EditForm(props) {
  const data = props.data
  const updatePayload = (payloadDelta) =>
    props.updatePayload(data.index, payloadDelta)
  const warehouseOptions = useSelector(warehouseOptionsSelector)

  return (
    <BaseEditForm className="medium-5 columns" {...props}>
      <Row>
        <TextInput
          value={data.payload.reference_id}
          errorMessage={data.errors.reference_id}
          name="reference_id"
          label="Reference ID"
          className="medium-8"
          onChange={(value) => updatePayload({reference_id: value})}
        />
      </Row>
      <Row>
        <Select
          value={data.payload.warehouse_id}
          errorMessage={data.errors.warehouse_id}
          name="warehouse_id"
          label="Warehouse"
          className="columns medium-12 wrap--full-select"
          selectClassName="full-width"
          onChange={(value) => updatePayload({warehouse_id: value})}
        >
          <option value="-1"></option>
          {warehouseOptions.map(({value, display}) => (
            <option key={value} value={value}>
              {display}
            </option>
          ))}
        </Select>
      </Row>
      <Row>
        <TextInput
          value={data.payload.shipping_amount}
          errorMessage={data.errors.shipping_amount}
          name="shipping_amount"
          rows="3"
          label="Shipping Cost"
          className="medium-6"
          onChange={(value) => updatePayload({shipping_amount: value})}
        />
        <TextInput
          value={data.payload.tax_amount}
          errorMessage={data.errors.tax_amount}
          name="tax_amount"
          rows="3"
          label="Tax Cost"
          className="medium-6"
          onChange={(value) => updatePayload({tax_amount: value})}
        />
      </Row>
      <Row>
        <TextArea
          value={data.payload.internal_notes}
          errorMessage={data.errors.internal_notes}
          name="internal_notes"
          rows="3"
          label="Internal Notes"
          className="medium-12"
          onChange={(value) => updatePayload({internal_notes: value})}
        />
      </Row>
      <Row>
        <TextArea
          value={data.payload.manufacturer_notes}
          errorMessage={data.errors.manufacturer_notes}
          name="manufacturer_notes"
          rows="3"
          label="Manufacturer Notes"
          className="medium-12"
          onChange={(value) => updatePayload({manufacturer_notes: value})}
        />
      </Row>
      <Row>
        <div className="medium-12 columns">
          <hr />
          <h5 className="margin-bottom-0">Order Contents</h5>
        </div>
      </Row>
      {data.payload.lines.map((line, index) => (
        <EditLine key={index} index={index} line={line} {...props} />
      ))}
    </BaseEditForm>
  )
}
